document.addEventListener('scroll', function onScroll() {
    // Get the scroll position
    var scrollPosition = window.scrollY || document.documentElement.scrollTop;

    // Get the viewport height
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;

    // Check if the scroll position is greater than or equal to 50% of the viewport height
    if (scrollPosition >= windowHeight / 2) {
        loadScript();
        // Remove the event listener once the script is loaded to avoid repeated loading
        document.removeEventListener('scroll', onScroll);
    }
});

function loadScript() {
    console.log('Review script loaded');
    
    // Create the select element
    var select = document.createElement('select');
    select.setAttribute('name', 'rating');
    select.setAttribute('id', 'rating');

    // Options for the select
    var options = ['All Ratings', '5 Stars', '4 Stars', '3 Stars', '2 Stars', '1 Star'];
    options.forEach(function(text, index) {
        var option = document.createElement('option');
        option.value = options.length - index; // Reverse the index for correct descending order
        option.textContent = text;
        select.appendChild(option);
    });

    // Container to hold the select element
    var div_select = document.createElement('div');
    var fir_div = document.createElement('div');
    var sec_div = document.createElement('div');
    var middl_div = document.createElement('div');

    fir_div.classList.add('vtl-pr__side-column');
    sec_div.classList.add('vtl-pr__side-column');
    middl_div.classList.add('vtl-pr-stats');

    var tit_text = document.createElement('h3');
    tit_text.textContent = "Sort reviews by:"; // Set the text for the h3 element
    div_select.classList.add("review_filter");
    middl_div.appendChild(tit_text); // Add the h3 element to the div
    middl_div.appendChild(select);

    div_select.appendChild(fir_div);
    div_select.appendChild(middl_div);
    div_select.appendChild(sec_div);

    // Find the container with class 'vtl-pr-rl__wrapper'
    var container = document.querySelector('.vtl-pr-rl__wrapper');
    if (container) {
        // Prepend the select element to the div with class 'vtl-pr-header'
        container.insertBefore(div_select, container.firstChild);
    }

    // Check for disabled bars and disable corresponding select options, excluding the first option
    var barItems = document.querySelectorAll('.vtl-pr-stats__bar-item');
    barItems.forEach(function(bar, index) {
        if (bar.classList.contains('vtl-pr-stats__bar-item--disabled')) {
            // Use the correct index for disabling corresponding option
            // Offset by 1 to exclude the first option ("All Ratings")
            select.options[index + 1].disabled = true;
        }
    });

    // Add event listener to the select element
    select.addEventListener('change', function() {
        // Get the selected option index
        var selectedIndex = this.selectedIndex - 1; // Offset by -1 to adjust for the "All Ratings" option

        // Check if the selected index corresponds to the "All Ratings" option
        if (selectedIndex < 0) {
            // Handle the "All Ratings" case, perhaps by activating all non-disabled bars
            barItems.forEach(function(bar) {
                if (!bar.classList.contains('vtl-pr-stats__bar-item--disabled') && bar.classList.contains('vtl-pr-stats__bar-item--active')) {
                    bar.click(); // Trigger click on active bar
                }
            });
        } else {
            var correspondingBar = barItems[selectedIndex]; // Get the bar corresponding to the selected index
            // Trigger click only if it's not disabled
            if (!correspondingBar.classList.contains('vtl-pr-stats__bar-item--disabled')) {
                correspondingBar.click(); // Trigger click on the corresponding bar
            }
        }
    });

    // Ensure dropdown reflects clicked bar status
    barItems.forEach(function(barItem, index) {
        barItem.addEventListener('click', function() {
            const starSpan = barItem.querySelector('.vtl-pr-stats__bar-stars span');
            if (starSpan) {
                const starText = starSpan.textContent.trim();
                const starNumber = starText.split(' ')[0]; // This assumes the text is like "5 Stars"

                // Update the selected option in the dropdown
                if (select) {
                    select.value = starNumber; // Assuming the option values directly correspond to the number of stars
                    select.dispatchEvent(new Event('change')); // Trigger change event to handle any attached listeners
                }
            }
        });
    });
}
